export default __webpack_public_path__ + "assets/cis-flag.png";